import { init, browserTracingIntegration, captureConsoleIntegration } from "@sentry/vue";

/**
 *
 * @param {import("vue-router").Router} router
 * @returns {import("vue").FunctionPlugin}
 */
export function createSentry(router) {
  return function (app) {
    init({
      app,
      dsn: "https://3c0df38e003214c4883c61c03373870c@o4511699948929024.ingest.de.sentry.io/4511700068270160",
      integrations: [browserTracingIntegration({ router }), captureConsoleIntegration({ levels: ["error"] })],
      ignoreErrors: ["AppError", "via a navigation guard", "Network Error"],
    });
  };
}
